export default "__VITE_ASSET__DwwnCABA__"